import api, { IPaginationResponse } from 'config/axios';

import AppService from 'common/app-service';
import { IUserRegistry, RegisterStatusTypes } from 'common/user.interface';

interface IPersonQueryParams {
  roleType?: 'admin' | 'customer' | 'users';
  email?: string;
  emailLike?: string;
}

export default class PersonService extends AppService {
  constructor() {
    super('persons', api);
  }

  async getById(id: number): Promise<IUserRegistry> {
    const response = await this.api.get(this.root(id));
    return response.data;
  }

  private roleTypeParam(roleType?: IPersonQueryParams['roleType']) {
    const customerRoles = ['torqi_customer_operator', 'torqi_customer_supervisor', 'torqi_customer_owner'];
    if (roleType === 'admin') return 'torqi_admin';
    if (roleType === 'users') return [...customerRoles, 'torqi_admin_financier'];
    return customerRoles;
  }

  async all(
    { email, emailLike, roleType }: IPersonQueryParams,
    page?: number,
    limit?: number
  ): Promise<IPaginationResponse<IUserRegistry>> {
    const response = await this.api.get(this.root(), {
      params: {
        email,
        emailLike,
        roleType: this.roleTypeParam(roleType),
        ...(page && limit ? { page, limit } : {}),
      },
    });
    return response.data;
  }

  async edit(id: number | string, params: Partial<IUserRegistry>): Promise<IUserRegistry> {
    const response = await this.api.put(this.root(id), params);
    return response.data;
  }

  async getCount({ registerStatusType }: { registerStatusType: RegisterStatusTypes }): Promise<any> {
    const response = await this.api.get(this.root('customers/count'), {
      params: {
        registerStatusType,
      },
    });
    return response.data.count;
  }
}
